import React, { useState } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import { ListGroup, Row, Col, Table } from 'react-bootstrap';
import JSONPretty from 'react-json-pretty';
import Nuovo_Progetto_Edit from "./Progetto_x0_menu";
import Visualizza_lista_documenti_pdf from "../Funzioni_comuni_pdf_visualizza.jsx";
import Visualizza_singolo_progetto from "./Progetto_x9_visualizza_singolo_progetto.jsx";
import Lista_icone from "./Pr_x6_1_lista_icone.jsx";
//import axios from "axios";




const Lista_Progetti = (props) => {
//    const [somma, calcola_somma] = useState('');



 

    return (
    <div className='container'>
        
        <h5> Per ordine di Creazione </h5>
                     
        <ListGroup>
            {/* www.idroslab.com */ }
            {Array.isArray(props.lista_progetti) && props.lista_progetti.map(function (item, index2) {
                {
                    //                            console.log('XXXadesso')
                    //                            console.log(item)
                    
                    return <div>
                        <Row>
                            < Nuovo_Progetto_Edit progetto={item} 
                                                    tutor={props.tutor} 
                                                    SET_variab_aggiorna={props.SET_variab_aggiorna} 
                                                    lista_alunni={props.lista_alunni}
                                                    lista_progetti={props.lista_progetti} />
                        </Row>
                        <Visualizza_singolo_progetto progetto={item} />
                        <Lista_icone progetto={item} classe_selezionata_item={props.classe_selezionata_item} /> 
                     
                        {Array.isArray(item.documentazione_array) && item.documentazione_array.length !== 0 && <>  
                        <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                        <th>#</th>
                                        <th>Tipologia</th>
                                        <th>Data Caricamento</th>
                                        
                                        <th>Tutor</th>
                                        <th>Admin</th>
                                
                                        <th>Azioni</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                         {/*------------------ AGGIORNARE MONGO QRCODE ---------------------------*/}   
            
                        <Visualizza_lista_documenti_pdf attore_tipo= {'progetto'} attore={item} tutor={props.tutor} tipologia_documento={'Foglio_firme_giornaliero'}  SET_variab_aggiorna={props.SET_variab_aggiorna}/> 
                        <Visualizza_lista_documenti_pdf attore_tipo= {'progetto'} attore={item} tutor={props.tutor} tipologia_documento={'Valutazione_finale'} SET_variab_aggiorna={props.SET_variab_aggiorna}/> 
                        </tbody>
                        </Table>
                        </> }

                         <hr class="rounded"></hr>
  
                        {(props.account_dati.utente_debug) &&
                                
                                <JSONPretty data={item} />
                        }

                    </div>
                }
            })
            }
        </ListGroup>
    </div>
    )
}
export default Lista_Progetti;